import React, { FunctionComponent, CSSProperties } from 'react';

type Props = {
  className: string;
  placeholder: string;
  options: {
    [label: string]: string;
  };
  onChanged: (name: string, value: string) => void;
  name: string;
  value: string | number;
  style?: CSSProperties
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  placeholder,
  options,
  onChanged,
  name,
  value,
  style,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChanged(name, event.target.value);
  };

  return (
    <select
      className={className}
      value={value}
      onChange={handleChange}
    >
      <option value="">
        {placeholder}
      </option>
      {Object.entries(options).map(([optionValue, optionLabel]) => (
        <option key={optionValue} value={optionValue}>
          {optionLabel}
        </option>
      ))}
    </select>
  );
};
